import { i18n } from "@lingui/core";

export const getLocalizedField = (obj, fieldName) => {
  const locale = i18n.locale;

  if (locale === "es" && obj[`${fieldName}Es`]) {
    return obj[`${fieldName}Es`];
  }

  if (locale === "en" && obj[`${fieldName}En`]) {
    return obj[`${fieldName}En`];
  }

  // fallback gdy czegoś brakuje
  return obj[`${fieldName}En`] || obj[fieldName] || "";
};